import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LangSwitcher from "../../../Component/LangSwitcher";
import LandingLogo from "./LandingLogo";
import { NAV_LINKS } from "../landingData";

const LandingNavbar = () => {
  const { t } = useTranslation("common");
  const navbarRef = useRef(null);

  useEffect(() => {
    const navbar = navbarRef.current;
    if (!navbar) {
      return undefined;
    }

    const handleScroll = () => {
      navbar.style.boxShadow = window.scrollY > 20 ? "0 8px 32px rgba(0,0,0,0.4)" : "none";
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAnchorClick = (event, href) => {
    if (!href.startsWith("#")) {
      return;
    }

    const target = document.querySelector(href);
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className="navbar" ref={navbarRef}>
      <div className="nav-inner">
        <LandingLogo />
        <div className="nav-links">
          {NAV_LINKS.map(({ href, labelKey }) => (
            <a key={href} href={href} onClick={(event) => handleAnchorClick(event, href)}>
              {t(labelKey)}
            </a>
          ))}
          <LangSwitcher className="nav-lang" />
          <Link to="/login" className="btn-nav">
            {t("Get Started")}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
